const DEFAULT_API = 'https://explored-api.guipinto.com/api/v1';

const apiBase = import.meta.env.VITE_API_BASE_URL ?? DEFAULT_API;

function deriveWsUrl(httpBase: string): string {
  const url = new URL(httpBase);
  url.protocol = url.protocol === 'https:' ? 'wss:' : 'ws:';
  url.pathname = url.pathname.replace(/\/$/, '') + '/cabin/ws';
  return url.toString();
}

export const config = {
  apiBaseUrl: apiBase,
  wsUrl: deriveWsUrl(apiBase),
  mapStyleUrl: 'https://tiles.openfreemap.org/styles/dark',
  pairPollIntervalMs: 2_000,
};
